import Swiper from 'swiper/bundle';
import $ from 'jquery';
export default function servicesSwiper() {
    let swiperService = new Swiper(".services-swiper", {
        slidesPerView: 1,
        rewind: true,
        spaceBetween: 30,
        navigation: {
            nextEl: ".services-swiper__button-next",
            prevEl: ".services-swiper__button-prev",
        },
        breakpoints: {
            1250: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            700: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            }
        }
    });


    $('.swiper-slide-service').on('click', function() {
        let href = $(this).find('a.service-swiper-link').attr('href');
        if(href) {
            window.location.href = href;
        }
    });
}